import React from 'react';
import LowInventoryItem from './LowInventoryItem';
import { useSelector } from 'react-redux';

function LowInventoryList() {
    const lowInventoryProducts = useSelector((state) => state.reportAnalysis.lowInventoryProducts.lowInventoryProducts);

    return (
        <div className="mt-6 mx-5">
            <div className="products-list">
                <div className="mt-3 border border-[#EAEAEA] rounded-lg">
                    <div className="flex bg-[#F5F5F5] text-[14px] leading-6 text-[#666666] font-semibold">
                        <h2 className="w-[55%] max-[1280px]:w-[47.5%] max-[1080px]:w-[43%] px-[10px] py-2 uppercase">Product</h2>
                        <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-2 uppercase">sku code</h2>
                        <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-2">Available Stock</h2>
                        <h2 className="w-[15%] max-[1280px]:w-[17.5%] max-[1080px]:w-[19%] px-[10px] py-2">Action</h2>
                    </div>

                    {lowInventoryProducts?.map(item => {
                        return (
                            <LowInventoryItem 
                                key={item.productId} 
                                item={item} 
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default LowInventoryList;
